<template>
  
  <v-app class="grey lighten-4">
    
    <v-content>
      <Nav-Bar v-on:emittedEvent="changeComponent($event)" :signedIn="signedIn" :admin="admin" :curComp="currentComponent" />
        <keep-alive>
          <component :is="currentComponent" :signedIn="signedIn" :admin="admin"> </component>
        </keep-alive>
    </v-content>
  
  </v-app>

</template>

<script>
import {bus} from './main.js';
import {auth} from './fb.js';
import HomePage from './components/HomePage';
import NavBar from './components/NavBar';

import Report from './components/Report';
import Forums from './components/New-Forums';
import ForumsExpanded from './components/ExpandedForums'
import Team from './components/Team';

import SignStuff from './components/SignStuff';
import Profile from './components/UserProfile';

import Maps from './components/Maps';
import Camera from './components/Cameras';

import AdminControls from './components/Admin'

export default {
  name: 'App',
  components: {
    'Home-Page': HomePage,
    'Nav-Bar': NavBar,
    'Report-Page': Report,
    'Maps-Page': Maps,
    'Forums-Page': Forums,
    'Forums-Expanded-Page': ForumsExpanded,
    'Team-Page': Team,
    'Camera-Page': Camera,
    'User-Profile': Profile,
    'Admin-Controls': AdminControls
  },
  created() {
    auth.onAuthStateChanged(user => { 
        if(user) {
            user.getIdTokenResult().then(idToken => {
              console.log(idToken.claims.admin);
              this.admin = true;
            })
            this.signedIn = true;
            // console.log('User Logged In ',user);
        } else {
            this.signedIn = false;
            // console.log('User is logged out');
        }
    });

    bus.$on("categoryChange", data => {
      this.currentComponent = data;
    });

   bus.$on("forumChange", data => {
      this.currentComponent = data;
    });
  },
  data () {
    return {
      currentComponent: 'Home-Page',
      signedIn: false,
      admin: false,
    }
  },
  methods: {
    changeComponent: function(event) {
      this.currentComponent = event;
    }
  }
}
</script>